import React, { Component } from 'react';
/* eslint-disable */

import axios from 'axios';
import { MY_API_URL, TINYMCEAPIKEY } from '../../Apanel/QueryMe';
import { Card, CardBody, Col, Badge, Table, Row } from 'reactstrap';
import BasicUserinfo from '../../Apanel/BasicUserinfo';
import ResultMeter from '../../Apanel/ResultMeter';
import TechName from '../../Apanel/TechName';
const apiurl = MY_API_URL;
var dateFormat = require('dateformat');

const initialstate = {
	questions: [],
	questionIndex: 0,
	result: [],
	currentDuration: 0,

	customtestsnotnow: false,
	showEbox: false,
	showAlert: false,
	alertType: '',
	alertText: '',
	verifiedTest: {},
	showDetails: true,
	closeall: false,
};
class Dashboard extends Component {
	constructor(props) {
		super(props);
	}
	state = { ...initialstate };
	componentDidMount() {
		localStorage.setItem('gotodash', 0);
		if (localStorage.profile_completed === '0') {
			localStorage.setItem('came_from', 'dashboard');
			this.props.history.push({
				pathname: '/profile',
				backTo: '/',
			});
		} else {
			this.fetchTests();
			this.fetchCustomTests();
		}
	}

	handleTestSubmit = (event) => {
		console.log(event);
		const headers = {
			'Content-Type': 'application/json',
			Authorization: localStorage.token,
		};
		var gpostData = {
			email: localStorage.by,
			testId: event,
		};
		console.log(event);
		const testidurl = apiurl + 'verifyTest';
		axios
			.post(testidurl, gpostData, {
				headers: headers,
			})
			.then((response) => {
				console.log(response.data.data);
				this.setState({
					showAlert: true,
					alertType: 'success',
					alertText: response.data.message,
					verifiedTest: response.data.data,
					showEbox: true,
					showCEbox: false,
					closeall: true,
				});
			})
			.catch((error) => {
				this.setState({
					alertType: 'danger',
					showAlert: true,
					alertText: 'Request Failed Try Again Later!',
				});
			});
	};
	handlecustomtestSubmit = (event) => {
		console.log(event);
		const headers = {
			'Content-Type': 'application/json',
			Authorization: localStorage.token,
		};
		var gpostData = {
			email: localStorage.by,
			testId: event,
		};
		console.log(event);
		const testidurl = apiurl + 'verifycutomTest';
		axios
			.post(testidurl, gpostData, {
				headers: headers,
			})
			.then((response) => {
				console.log(response.data.data);
				this.setState({
					showAlert: true,
					alertType: 'success',
					alertText: response.data.message,
					verifiedTest: response.data.data,
					showCEbox: true,
					showEbox: false,
					closeall: true,
				});
			})
			.catch((error) => {
				this.setState({
					alertType: 'danger',
					showAlert: true,
					alertText: 'Request Failed Try Again Later!',
				});
			});
	};
	redirectUser = () => {
		localStorage.setItem('testId', this.state.verifiedTest.id);
		localStorage.setItem('ttypefor', this.state.verifiedTest.ttype);
		localStorage.setItem('test', JSON.stringify(this.state.verifiedTest));
		localStorage.setItem(
			'questionIndex',
			localStorage.getItem('testId') === this.state.verifiedTest.id &&
				localStorage.getItem('questionIndex')
				? localStorage.getItem('questionIndex') + 1
				: 0,
		);
		if (this.state.verifiedTest.ttype == 'cus') {
			this.props.history.push('/customstarttest', {
				test: this.state.verifiedTest,
			});
		} else {
			this.props.history.push('/starttest', {
				test: this.state.verifiedTest,
			});
		}
	};
	fetchTests = () => {
		const headers = {
			'Content-Type': 'application/json',
			Authorization: localStorage.token,
		};
		var postData = {
			email: localStorage.by,
		};
		const getuurl = apiurl + 'fetchTests';
		axios
			.post(getuurl, postData, {
				headers: headers,
			})
			.then((response) => {
				console.log('Data is', response.data.data);
				this.setState({
					tests: [...response.data.data],
					akeywords: response.data.akeywords,
				});
			})
			.catch((error) => {
				console.log(error);
			});
	};
	fetchCustomTests = () => {
		const headers = {
			'Content-Type': 'application/json',
			Authorization: localStorage.token,
		};
		var postData = {
			email: localStorage.by,
		};
		const getuurl = apiurl + 'fetchcustomTests';
		axios
			.post(getuurl, postData, {
				headers: headers,
			})
			.then((response) => {
				console.log('custom Data is', response.data.data);
				this.setState({
					customtests: [...response.data.data],
				});
			})
			.catch((error) => {
				console.log(error);
			});
	};
	getDetails = (techid) => {
		// console.log('normal ', techid);
		techid = parseInt(techid, 0);
		let techname = this.state.akeywords.filter((tt) => {
			return tt.id === techid;
		});
		// console.log(techname[0].keyword);
		return techname[0].keyword;
	};
	render() {
		const { showEbox, showAlert, alertType, alertText } = this.state;
		let comptindex = 1;
		let cuscomptest = 1;
		return (
			<div>
				{this.state.showEbox ? (
					<div className="account">
						<div className="account__wrapper">
							<div className="account__card">
								<div className="account__head">
									<h3 className="account__title">
										<span className="account__logo">
											Welcome to the
											<span className="account__logo-accent"> test!</span>
										</span>
									</h3>
								</div>

								<div style={{ color: 'red' }}>
									Read these instructions very carefully
								</div>
								<ul>
									<li>
										This test will take {this.state.verifiedTest.duration}{' '}
										minutes time to be completed
									</li>
									<li>You have to complete your test in one sitting</li>
									<li>
										Make sure you are connected to a stable internet connection
									</li>
									<li>
										Every question has an alloted time, if that that time is
										exceeded you will be automatically moved to the next
										Question
									</li>
								</ul>
								<div className="account__or">
									<p>*</p>
								</div>
								<button
									className="btn btn-primary account__btn account__btn--small"
									onClick={this.redirectUser}
								>
									Start Test
								</button>
							</div>
						</div>
					</div>
				) : (
					<div>
						{this.state.closeall ? null : (
							<div>
								{this.state.tests ? (
									<Row>
										{this.state.tests &&
											this.state.tests.map((test, index) => {
												if (test.taken <= 0) {
													return (
														<Col md={3} key={index}>
															<Card>
																<CardBody className="dashboard__health-chart-card">
																	<div className="card__title">
																		<h4 className="bold-text card__title-center">
																			{test.generated_id}
																		</h4>
																		<ul className="list-group list-group-flush">
																			<li className="list-group-item">
																				<b>From: </b>
																				{test.name}
																			</li>
																			<li className="list-group-item">
																				{test.sent_by}
																			</li>
																		</ul>
																		{test.technologies &&
																			test.technologies.map(
																				(technology, index) => {
																					return (
																						<Badge
																							key={index}
																							color="success"
																							style={{
																								padding: '5px',
																								margin: '5px',
																							}}
																						>
																							{this.getDetails(technology)}
																						</Badge>
																					);
																				},
																			)}
																	</div>

																	<button
																		className="btn btn-primary btn-block btn-sm"
																		onClick={this.handleTestSubmit.bind(
																			this,
																			test.id,
																		)}
																	>
																		Take Test
																	</button>
																</CardBody>
															</Card>
														</Col>
													);
												}
											})}
									</Row>
								) : null}
							</div>
						)}
					</div>
				)}
				{this.state.showCEbox ? (
					<div className="account">
						<div className="account__wrapper">
							<div className="account__card">
								<div className="account__head">
									<h3 className="account__title">
										<span className="account__logo">
											Welcome to the
											<span className="account__logo-accent">
												{' '}
												Custom test!
											</span>
										</span>
									</h3>
								</div>

								<div style={{ color: 'red' }}>
									Read these instructions very carefully
								</div>
								<ul>
									<li>You have to complete your test in one sitting</li>
									<li>
										Make sure you are connected to a stable internet connection
									</li>
									<li>
										Every question has an alloted time, if that that time is
										exceeded you will be automatically moved to the next
										Question
									</li>
								</ul>
								<div className="account__or">
									<p>*</p>
								</div>
								<button
									className="btn btn-primary account__btn account__btn--small"
									onClick={this.redirectUser}
								>
									Start Test
								</button>
							</div>
						</div>
					</div>
				) : (
					<div>
						{this.state.closeall ? null : (
							<div>
								{this.state.customtests ? (
									<Row>
										{this.state.customtests &&
											this.state.customtests.map((customtest, index) => {
												if (customtest.taken <= 0) {
													return (
														<Col md={3} key={index}>
															<Card>
																<CardBody className="dashboard__health-chart-card">
																	<div className="card__title">
																		<h4 className="bold-text card__title-center">
																			{customtest.testname}
																		</h4>
																		<ul className="list-group list-group-flush">
																			<li className="list-group-item">
																				<b>From: </b>
																				{customtest.name}
																			</li>
																			<li className="list-group-item">
																				{customtest.sent_by}
																			</li>
																		</ul>
																	</div>

																	<button
																		className="btn btn-primary btn-block btn-sm"
																		onClick={this.handlecustomtestSubmit.bind(
																			this,
																			customtest.id,
																		)}
																	>
																		Take Custom Test
																	</button>
																</CardBody>
															</Card>
														</Col>
													);
												}
											})}
									</Row>
								) : null}

								<Col md={12}>
									<Card>
										<CardBody>
											<div className="card__title">
												<h5 className="bold-text">Completed Test Details</h5>
											</div>
											{this.state.tests ? (
												<Table responsive hover>
													<thead>
														<tr>
															<th>#</th>
															<th>Test ID</th>
															<th>Test Taken</th>
															<th>Technologies</th>
															<th>
																<span style={{ fontSize: '12px' }}>
																	Correct/InCorrect/UnAttempted
																</span>
															</th>
															<th>Result</th>
														</tr>
													</thead>
													<tbody>
														{this.state.tests &&
															this.state.tests.map((test, index) => {
																if (test.taken === 1) {
																	var myresult = JSON.parse(test.helper);
																	var allresults = JSON.parse(test.results);
																	// console.log('results here ', allresults);
																	let totalCorrect = 0;
																	let totalIncorrect = 0;
																	let totalUnattempted = 0;
																	let totalquestions = 0;

																	allresults.map((result, index) => {
																		totalCorrect += result.correct;
																		totalIncorrect += result.incorrect;
																		totalUnattempted += result.unattempted;
																	});
																	myresult.map((resul, index) => {
																		resul.questions = parseInt(resul.questions);
																		totalquestions += resul.questions;
																	});
																	totalCorrect =
																		(100 / totalquestions) * totalCorrect;
																	return (
																		<tr key={index}>
																			<td>{comptindex++}</td>

																			<td>
																				<h4>{test.generated_id}</h4>
																				<p>
																					From:
																					{test.name}
																					<br />
																					Email: {test.sent_by}
																					<br />
																					Mobile: {test.mobile}
																					<br />
																					{test.domain}
																				</p>
																			</td>

																			<td>
																				{dateFormat(test.taken_at, 'd-m-yyyy')}
																			</td>
																			<td>
																				<h4>
																					{test.technologies &&
																						test.technologies.map(
																							(technology, index) => {
																								return (
																									<Badge
																										key={index}
																										color="success"
																										style={{
																											padding: '5px',
																											margin: '5px',
																										}}
																									>
																										{this.getDetails(
																											technology,
																										)}
																									</Badge>
																								);
																							},
																						)}
																				</h4>
																			</td>
																			<td>
																				<ResultMeter
																					marks={totalCorrect}
																					mmarks={totalquestions}
																				/>
																			</td>
																			<td>
																				<strong
																					style={{ cursor: 'pointer' }}
																					onClick={() => {
																						this.props.history.push({
																							pathname: '/testreport',
																							testId: test.id,
																							email: localStorage.by,
																						});
																					}}
																				>
																					View Result
																				</strong>
																			</td>
																		</tr>
																	);
																}
															})}
													</tbody>
												</Table>
											) : null}
										</CardBody>
									</Card>

									<Card>
										<CardBody>
											<div className="card__title">
												<h5 className="bold-text">
													Completed Custom Test Details
												</h5>
											</div>

											<Table responsive hover>
												<thead>
													<tr>
														<th>#</th>
														<th>Test Name</th>
														<th>Test Taken</th>
														<th>
															<span style={{ fontSize: '12px' }}>
																Correct/InCorrect/UnAttempted
															</span>
														</th>
														{/* <th>Result</th> */}
													</tr>
												</thead>
												<tbody>
													{this.state.customtests &&
														this.state.customtests.map((test, index) => {
															if (test.taken === 1) {
																var allresults = JSON.parse(test.results);
																// console.log('results here ', allresults);
																let allcusques = test.question_ids;
																let allcusquescnt = allcusques.split(',');
																let totalCorrect = parseInt(
																	allresults[0].correct,
																	0,
																);
																let totalIncorrect = parseInt(
																	allresults[0].incorrect,
																	0,
																);
																let totalUnattempted = parseInt(
																	allresults[0].unattempted,
																	0,
																);
																let totalquestions = allcusquescnt.length;

																totalCorrect =
																	(100 / totalquestions) * totalCorrect;
																return (
																	<tr key={index}>
																		<td>{cuscomptest++}</td>

																		<td>
																			<h4>{test.testname} </h4>
																		</td>

																		<td>
																			{dateFormat(test.taken_at, 'd-m-yyyy')}
																		</td>

																		<td>
																			<ResultMeter
																				marks={totalCorrect}
																				mmarks={totalquestions}
																			/>
																		</td>
																		{/* <td>
																		<strong
																			style={{ cursor: 'pointer' }}
																			onClick={() => {
																				localStorage.setItem(
																					'cusreporttestId',
																					test.id,
																				);

																				this.props.history.push(
																					'/customtestreport',
																				);
																			}}
																		>
																			View Result
																		</strong>
																	</td> */}
																	</tr>
																);
															}
														})}
												</tbody>
											</Table>
										</CardBody>
									</Card>
								</Col>
							</div>
						)}
					</div>
				)}
				;
			</div>
		);
	}
}

export default Dashboard;
